export const departmentsAccordion = () => {
  const departmentsSections = document.querySelectorAll(".departments");

  if (!departmentsSections.length) {
    return;
  }

  departmentsSections.forEach((section) => {
    const departmentRows = Array.from(section.querySelectorAll(".department"));

    if (!departmentRows.length) {
      return;
    }

    const items = departmentRows
      .map((department) => {
        const reveal = department.nextElementSibling;
        const hasReveal = reveal?.classList.contains("reveal");

        if (!hasReveal) {
          return null;
        }

        let content = reveal.querySelector(".reveal__content");

        if (!content) {
          content = document.createElement("div");
          content.className = "reveal__content";

          while (reveal.firstChild) {
            content.appendChild(reveal.firstChild);
          }

          reveal.appendChild(content);
        }

        const buttons = Array.from(
          department.querySelectorAll(".department__btn")
        );

        if (!buttons.length) {
          return null;
        }

        const revealId =
          reveal.id ||
          `department-reveal-${Math.random().toString(36).slice(2, 10)}`;
        reveal.id = revealId;
        reveal.setAttribute("aria-hidden", "true");

        buttons.forEach((button) => {
          button.setAttribute("aria-controls", revealId);
          button.setAttribute("aria-expanded", "false");
          button.setAttribute("role", "button");
        });

        return { department, reveal, buttons };
      })
      .filter(Boolean);

    if (!items.length) {
      return;
    }

    // Funkcja zarządzająca stanem (otwarty / zamknięty) oraz obrazkiem
    const setItemState = (item, isOpen) => {
      item.department.classList.toggle("is-open", isOpen);
      item.reveal.classList.toggle("is-open", isOpen);
      item.reveal.setAttribute("aria-hidden", String(!isOpen));

      item.buttons.forEach((button) => {
        button.setAttribute("aria-expanded", String(isOpen));

        // Aktualizacja ikony wewnątrz przycisku
        const img = button.querySelector("img");
        if (img) {
          img.classList.toggle("department__btn-icon--active", isOpen);
          img.src = isOpen
            ? `${themeUrl}/src/img/ico/minus-white.svg`
            : `${themeUrl}/src/img/ico/plus-white.svg`;
        }
      });
    };

    const closeAll = () => {
      items.forEach((item) => setItemState(item, false));
    };

    // Stan początkowy - zamknij wszystko
    closeAll();

    // Nasłuchiwanie kliknięć
    items.forEach((item) => {
      item.buttons.forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();

          const isOpen = item.department.classList.contains("is-open");

          closeAll();

          if (!isOpen) {
            setItemState(item, true);
          }
        });
      });
    });
  });
};